// ============================================================
// SOCCER TRAINER — Dados editáveis do site
// Edite este arquivo para atualizar horários, equipe, unidades,
// galeria, eventos e metodologia. Não é preciso mexer nos componentes.
// ============================================================

export const WHATSAPP_URL = "https://wa.me/5531996874610";
export const WHATSAPP_DISPLAY = "(31) 99687-4610";
export const INSTAGRAM_URL = "https://instagram.com/soccertrainerpatos";
export const LINKTREE_URL = "https://linktr.ee/soccertrainer";

export const NAV_LINKS = [
  { id: "inicio", label: "Início" },
  { id: "sobre", label: "Sobre" },
  { id: "metodologia", label: "Metodologia" },
  { id: "categorias", label: "Categorias e Horários" },
  { id: "espaco", label: "Nosso Espaço" },
  { id: "profissionais", label: "Profissionais" },
  { id: "eventos", label: "Eventos" },
  { id: "contato", label: "Contato" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1487466365202-1afdb86c764e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHx5b3V0aCUyMHNvY2NlciUyMHN0YWRpdW0lMjB0cmFpbmluZyUyMG5pZ2h0JTIwbGlnaHRzfGVufDB8fHx8MTc5MDIwMTYyM3ww&ixlib=rb-4.1.0&q=85";

export const SOBRE_IMAGE = "/assets/local-2.jpg";

// ---------- Metodologia (Planejamento Mensal — SUB-5 ao SUB-15) ----------
export const METODOLOGIA = {
  objetivoGeral:
    "Desenvolver os fundamentos técnicos e cognitivos do futebol de forma progressiva, respeitando a faixa etária de cada categoria e promovendo aprendizagem por meio de jogos e situações reais.",
  categorias: "Categorias SUB-5 ao SUB-15",
  semanas: [
    {
      numero: 1,
      tema: "Fundamentos",
      conteudos: [
        { cat: "SUB-5", texto: "Passe, condução e controle de bola." },
        { cat: "SUB-7", texto: "Domínio, devolução de primeira/segunda, passe e condução." },
        { cat: "SUB-9", texto: "Fundamentos técnicos, passe com precisão e controle de bola." },
        { cat: "SUB-11", texto: "Fundamentos técnicos, arremates e passes dinâmicos." },
        { cat: "SUB-13", texto: "Passes dinâmicos em losango e quadrado." },
        { cat: "SUB-15", texto: "Passes dinâmicos em losango e quadrado com maior intensidade e velocidade." },
      ],
      objetivos: [
        "Melhorar a coordenação motora.",
        "Desenvolver domínio e controle da bola.",
        "Aprimorar qualidade do passe.",
        "Estimular a tomada de decisão.",
      ],
      organizacao: null,
    },
    {
      numero: 2,
      tema: "Finalização",
      conteudos: [
        { cat: "SUB-5", texto: "Finalizações simples e com as mãos. Aula 1: finalizações simples. Aula 2: finalizações com obstáculos." },
        { cat: "SUB-7", texto: "Introdução às finalizações utilizando os pés." },
        { cat: "SUB-9", texto: "Finalizações básicas em movimento." },
        { cat: "SUB-11", texto: "Aula 1: finalizações simples." },
        { cat: "SUB-13", texto: "Aula 2: finalização ao gol combinada." },
        { cat: "SUB-15", texto: "Aula 2: finalização ao gol combinada em velocidade." },
      ],
      objetivos: [
        "Desenvolver técnica de chute.",
        "Trabalhar coordenação entre condução e finalização.",
        "Melhorar precisão.",
        "Estimular confiança na conclusão das jogadas.",
      ],
      organizacao: null,
    },
    {
      numero: 3,
      tema: "Pequenos Jogos",
      conteudos: [
        { cat: "SUB-5", texto: 'Confrontos 1x1, 2x2 e brincadeira "Derruba Cones".' },
        { cat: "SUB-7", texto: "Jogos 1x1 sem gol, incentivando o enfrentamento individual." },
        { cat: "SUB-9", texto: "Jogos reduzidos: 1x1, 2x2, 3x3 e 4x4." },
        { cat: "SUB-11", texto: "Superioridade numérica: 2x1, 3x2 e 4x3." },
        { cat: "SUB-13", texto: 'Jogos "Alemão", Golzinho e Gol Médio.' },
        { cat: "SUB-15", texto: "Pequenos jogos em alta intensidade e tomada de decisão." },
      ],
      objetivos: [
        "Estimular criatividade.",
        "Desenvolver tomada de decisão.",
        "Melhorar leitura de jogo.",
        "Favorecer situações reais de jogo.",
      ],
      organizacao: [
        "1ª aula: confrontos",
        "2ª aula: jogos reduzidos",
        "Aquecimento já iniciado com pequenos jogos",
      ],
    },
    {
      numero: 4,
      tema: "Jogo Coletivo",
      conteudos: [
        { cat: "SUB-5", texto: "Aquecimento com atividades coordenativas e jogos coletivos." },
        { cat: "SUB-7", texto: "Coordenação e coletivo." },
        { cat: "SUB-9", texto: "Coordenação e coletivo." },
        { cat: "SUB-11", texto: "Aquecimento com força, velocidade e coletivo." },
        { cat: "SUB-13", texto: "Força, velocidade e jogo coletivo." },
        { cat: "SUB-15", texto: "Força, velocidade máxima e jogo coletivo." },
      ],
      objetivos: [
        "Integrar os conteúdos trabalhados durante o mês.",
        "Desenvolver entendimento coletivo.",
        "Melhorar posicionamento.",
        "Aplicar fundamentos em situações de jogo.",
      ],
      organizacao: null,
    },
  ],
  progressao: [
    { titulo: "Semana 1", texto: "Aprender os fundamentos." },
    { titulo: "Semana 2", texto: "Aplicar os fundamentos nas finalizações." },
    { titulo: "Semana 3", texto: "Utilizar os fundamentos em pequenos jogos." },
    { titulo: "Semana 4", texto: "Transferir todo o aprendizado para o jogo coletivo." },
  ],
  lema: "Aprender • Repetir • Competir • Jogar",
  sublema: "Muita bola, decisões e diversão!",
};

// ---------- Categorias e horários (Programação 2026) ----------
// anos: anos de nascimento atendidos pela turma (usado no filtro)
export const HORARIOS = [
  { id: "sub5", categoria: "SUB 5", anos: [2020, 2021], anosLabel: "2020 / 2021", dias: "Terça e Quinta", horario: "18:10", campo: "natural" },
  { id: "sub7", categoria: "SUB 7", anos: [2018, 2019], anosLabel: "2018 / 2019", dias: "Segunda e Quarta", horario: "18:10", campo: "sintetico" },
  { id: "sub9", categoria: "SUB 9", anos: [2016, 2017], anosLabel: "2016 / 2017", dias: "Terça e Quinta", horario: "18:10", campo: "sintetico" },
  { id: "sub11", categoria: "SUB 11", anos: [2014, 2015], anosLabel: "2014 / 2015", dias: "Segunda e Quarta", horario: "19:10", campo: "natural" },
  { id: "sub13", categoria: "SUB 13", anos: [2012, 2013], anosLabel: "2012 / 2013", dias: "Terça e Quinta", horario: "19:10", campo: "sintetico" },
  { id: "sub15", categoria: "SUB 15", anos: [2010, 2011], anosLabel: "2010 / 2011", dias: "Terça e Quinta", horario: "19:10", campo: "natural" },
];

export const MODALIDADES = [
  {
    nome: "Treino de Goleiro",
    descricao: "Trabalho específico de posicionamento, defesas, saída de bola e jogo aéreo para goleiros de todas as categorias.",
  },
  {
    nome: "Treino de Alto Rendimento",
    descricao: "Preparação técnica, tática e física intensiva para atletas com potencial de carreira profissional.",
  },
  {
    nome: "Turma Iniciante",
    descricao: "Primeiros passos no futebol com diversão, coordenação motora e fundamentos para quem está começando.",
  },
];

// ---------- Nosso Espaço ----------
// Fotos reais da Arena Marabá (unidade), extraídas do Google Maps.
// Para trocar, substitua os arquivos em public/assets ou aponte para outro caminho.
export const GALERIA = [
  { src: "/assets/local-1.jpg", alt: "Entrada da Arena Marabá, unidade da Soccer Trainer" },
  { src: "/assets/local-2.jpg", alt: "Campo de grama natural iluminado da Arena Marabá" },
  { src: "/assets/local-11.jpg", alt: "Vista aérea noturna do complexo Arena Marabá" },
  { src: "/assets/local-12.jpg", alt: "Panorâmica noturna dos campos da Arena Marabá" },
  { src: "/assets/local-15.jpg", alt: "Campo society visto de trás do gol" },
  { src: "/assets/local-5.jpg", alt: "Quadra iluminada para treinos noturnos" },
  { src: "/assets/local-17.jpg", alt: "Campo de treino com refletores ao entardecer" },
  { src: "/assets/local-7.jpg", alt: "Área esportiva da Arena Marabá ao pôr do sol" },
  { src: "/assets/local-20.jpg", alt: "Complexo Arena Marabá visto de cima à noite" },
];

export const ESTRUTURA = [
  { nome: "Campo de Grama Natural", descricao: "Gramado natural aparado e irrigado para treinos e jogos de campo.", icone: "Sprout" },
  { nome: "Campo Sintético (Society)", descricao: "Society de última geração com iluminação de LED para treinos noturnos.", icone: "Layers" },
  { nome: "Área de Preparação Física", descricao: "Espaço dedicado a força, velocidade e prevenção de lesões.", icone: "Dumbbell" },
  { nome: "Convivência para os Pais", descricao: "Área confortável e segura para a família acompanhar os treinos.", icone: "Users" },
];

export const UNIDADES = [
  {
    nome: "Arena Marabá",
    endereco: "Av. Marabá, 1129 — Bela Vista, Patos de Minas/MG — CEP 38703-236",
    mapsQuery: "Av. Marabá, 1129, Bela Vista, Patos de Minas, MG",
  },
];

// ---------- Profissionais ----------
// Fotos enviadas pela escola em public/assets. Para trocar, substitua o arquivo.
export const FUNDADOR = {
  nome: "Thales Santos Affá",
  cargo: "Coordenador e Professor",
  foto: "/assets/thales.png",
  bio: "Ex-atleta profissional de futebol, é coordenador e professor da Soccer Trainer desde 2011. Licença B — CBF Academy. Organizador da Patos Cup e parceiro das equipes de base de Patos de Minas.",
};

export const CURRICULO = {
  licenca: "Licença B — CBF Academy",
  atleta: [
    "Atlético Mineiro/MG",
    "Araxá/MG",
    "BH Futebol/MG",
    "Inter de Limeira/SP",
    "Mamoré/MG",
    "Patrocinense/MG",
    "Comercial/MA",
  ],
  comissao: [
    { periodo: "2010", clube: "BH Futebol/MG", funcao: "Preparador Físico" },
    { periodo: "2014", clube: "Ipatinga/MG", funcao: "Preparador Físico" },
    { periodo: "2015–2016", clube: "Cruzeiro/MG", funcao: "Análise de desempenho SUB-17/SUB-20 e auxiliar do profissional" },
    { periodo: "2019", clube: "Patrocinense/MG", funcao: "Preparador Físico e Auxiliar Técnico" },
    { periodo: "2019", clube: "URT/MG", funcao: "Preparador Físico e Auxiliar Técnico" },
    { periodo: "2022", clube: "Mamoré/MG", funcao: "Preparador Físico" },
    { periodo: "2023", clube: "Mirassol/SP", funcao: "Treinador SUB-14 e Auxiliar SUB-20" },
    { periodo: "2026 — Atual", clube: "Brasília/DF", funcao: "Preparador Físico" },
  ],
  conquistas: ["Campeão Mineiro SUB-20", "Campeão da Copa do Brasil 2016 — Cruzeiro"],
};

export const EQUIPE = [
  {
    titulo: "Equipe Soccer Trainer",
    subtitulo: null,
    bio: "Integrante da equipe Soccer Trainer no dia a dia dos treinos e amistosos.",
    foto: "/assets/equipe-1.png",
    instagram: INSTAGRAM_URL,
  },
  {
    titulo: "Equipe Soccer Trainer",
    subtitulo: null,
    bio: "Integrante da equipe Soccer Trainer no dia a dia dos treinos e amistosos.",
    foto: "/assets/prof-2.png",
    instagram: INSTAGRAM_URL,
  },
  {
    titulo: "Equipe Soccer Trainer",
    subtitulo: null,
    bio: "Integrante da equipe Soccer Trainer no dia a dia dos treinos e amistosos.",
    foto: "/assets/prof-thales.png",
    instagram: INSTAGRAM_URL,
  },
];

// ---------- Eventos e conquistas ----------
export const EVENTOS = [
  {
    titulo: "Patos Cup",
    descricao: "Torneio de categorias de base organizado pela Soccer Trainer, com dezenas de equipes de várias cidades mineiras: Belo Horizonte, Formiga, Monte Carmelo, João Pinheiro e Patrocínio.",
    tag: "Torneio próprio",
    icone: "Trophy",
  },
  {
    titulo: "Copa Soccer",
    descricao: "Competição interna organizada pela Soccer Trainer, colocando em prática todo o planejamento mensal em jogos entre as categorias da escola.",
    tag: "Torneio próprio",
    icone: "Trophy",
  },
  {
    titulo: "Peneira com observador do Corinthians",
    descricao: "Atletas da escola participaram de peneira com observador oficial do Corinthians acompanhando os treinos.",
    tag: "Oportunidade profissional",
    icone: "Star",
  },
  {
    titulo: "Copa da Amizade",
    descricao: "Competição que reúne escolas e equipes da região em jogos de integração e fair play.",
    tag: "Competição",
    icone: "Handshake",
  },
  {
    titulo: "Mundial Sub 13",
    descricao: "Participação da categoria SUB 13 em competição de nível internacional de base.",
    tag: "Internacional",
    icone: "Globe",
  },
];

export const DEPOIMENTOS = [
  {
    nome: "Mariana S.",
    relacao: "Mãe de atleta SUB 9",
    texto: "Meu filho evoluiu demais desde que entrou na Soccer Trainer. Os professores acompanham cada detalhe e ele conta os dias para o treino.",
  },
  {
    nome: "Carlos H.",
    relacao: "Pai de atleta SUB 13",
    texto: "Estrutura excelente e metodologia séria. O Thales e a equipe tratam as crianças como atletas de verdade, com carinho e disciplina.",
  },
  {
    nome: "Pedro, 14 anos",
    relacao: "Atleta SUB 15",
    texto: "Aqui aprendi a treinar forte e a sonhar grande. Os amistosos e torneios me deram experiência de jogo de verdade.",
  },
];

// ---------- Contato ----------
export const MODALIDADES_INTERESSE = [
  "Categorias de base (SUB 5 a SUB 15)",
  "Treino de Goleiro",
  "Treino de Alto Rendimento",
  "Turma Iniciante",
];

export const AULA_EXPERIMENTAL_MSG =
  "Olá! Quero agendar uma aula experimental na Soccer Trainer para meu filho(a).";

// ---------- Vídeo ----------
// Vídeo exibido no final da seção Eventos e Conquistas (public/assets/treino.mp4)
export const VIDEO_TREINO = "/assets/treino.mp4";
